export enum OptionsEnum {
  TERM = 'Term',
  AMOUNT = 'Amount',
  INSTALLMENT = 'Installment',
  TIR = 'Tir',
}

export interface CounterOfferData {
  id: string;
  name: string;
  term: number;
  requested_amount: number;
  financial: Financial;
  opening_fee_type: string;
}

export interface Financial {
  signature_date: number;
  first_due: number;
  financed_amount: number;
  disbursement_amount: number;
  discount_amount: number;
  opening_fee_amount: number;
  expenses_amount: number;
  tae: number;
  tir: number;
  weighted_tir: number;
  installments: Installment[];
}

export interface Installment {
  tranche_id: number;
  due_number: number;
  due_date: number;
  fee: number;
  principal: number;
  interest: number;
  opening_fee: number;
  insurance: number;
  pending_amount: number;
  interest_rate: number;
  amortized_pct: number;
}